import type {
  FieldValue,
  FormField
} from '@elfsight/widget-form-builder/widget';
import { STRING_TYPES } from '../constants';
import {
  isSubmissionValidatorKey,
  submissionValidators
} from './submissionValidators';
import { validateAllowedValue } from './validateAllowedValue';

export const validateAPIValue = (
  value: unknown,
  field: FormField
): [FieldValue, boolean] | undefined => {
  const { type: fieldType } = field;
  if (!fieldType || !validateAllowedValue(value)) {
    return;
  }

  if (STRING_TYPES.some((type) => type === fieldType)) {
    return submissionValidators.stringType(value, field);
  }

  if (isSubmissionValidatorKey(fieldType)) {
    return submissionValidators[fieldType](value, field);
  }

  return;
};
